export default "__VITE_ASSET__BEUF0KKF__"